import React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from '../messages';

// noinspection JSValidateTypes
const ShippingServiceLabel = () => <FormattedMessage {...messages.shippingService} />;

export default ShippingServiceLabel;
